import { Routes, Route } from 'react-router-dom'
import { PaletteProvider } from './context/PaletteContext'
import Header from './components/Header'
import Footer from './components/Footer'
import ScrollToTop from './components/ScrollToTop'
import Home from './pages/Home'
import About from './pages/About'
import Services from './pages/Services'
import ServiceDetail from './pages/ServiceDetail'
import Prices from './pages/Prices'
import Contact from './pages/Contact'
import DynamicPage from './pages/DynamicPage'
import NotFound from './pages/NotFound'
import Forbidden from './pages/Forbidden'

export default function App() {
  return (
    <PaletteProvider>
      <div className="relative min-h-screen flex flex-col bg-brand-offwhite antialiased">
        {/* Scroll Restoration */}
        <ScrollToTop />

        {/* Header / Navigation */}
        <Header />

        {/* Main Content Area */}
        <main className="flex-grow">
          <Routes>
            {/* Main Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/om-mig" element={<About />} />
            <Route path="/psykoterapi" element={<DynamicPage />} />
            <Route path="/ydelser" element={<Services />} />
            <Route path="/ydelser/:slug" element={<ServiceDetail />} />
            <Route path="/priser" element={<Prices />} />
            <Route path="/kontakt" element={<Contact />} />

            {/* Legal / Dynamic Pages */}
            <Route path="/privacy-policy" element={<DynamicPage />} />
            <Route path="/cookie-policy-eu" element={<DynamicPage />} />

            {/* Error Pages */}
            <Route path="/403" element={<Forbidden />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>

        {/* Footer */}
        <Footer />
      </div>
    </PaletteProvider>
  )
}
